module.exports = __webpack_public_path__ + "static/media/keep-safe-tip05.0598e596.png";